import type {Data, DataValue, Part} from 'schemaDefinition/types';
import {makePartPath} from './makePartPath';

export const getValue = (
  data: Data | undefined,
  part: Part,
  valuePath: string,
): {value: DataValue | undefined; valuePath: string} => {
  const path = makePartPath(valuePath, part);
  const value = part.name ? data?.[part.name] : undefined;
  return {value, valuePath: path};
};
